// @flow
import type { SelectorProps } from '../../util/redux'
import { deviceSelector } from '../device/selectors'
import type { State } from '../../store/store'

export type ScheduleSelectorProps = {
  match: {
    params: {
      locationId: string,
      scheduleId: string,
      zoneId: string
    }
  }
}

export const getScheduleInState = (state: State, scheduleId: string) => {
  return state.schedule[scheduleId] && state.schedule[scheduleId].created
    ? state.schedule[scheduleId]
    : null
}

export const scheduleSelector = (
  state: State,
  props: ScheduleSelectorProps
) => {
  return getScheduleInState(state, props.match.params.scheduleId)
}

export const schedulesSelector = (
  state: State,
  props: SelectorProps
): ?Array<Object> => {
  const device = deviceSelector(state, props)
  return device && device.META.scheduleIds
    ? device.META.scheduleIds
        .filter(
          scheduleId =>
            state.schedule[scheduleId] && state.schedule[scheduleId].created
        )
        .map(scheduleId => state.schedule[scheduleId])
    : null
}

/**
 * pseudo-selector to compare device.META.scheduleIds array to the schedule reducer to makes sure
 * we have schedule data for each of the device's scheduleIds
 * @param {Object} state the Store 'devices' reducer
 * @param {Array} props the Store 'schedules' schedule data in the form of an array
 * @return {bool} whether we have the data for all of the schedules needed
 */
export const allSchedulesFetched = (
  state: State,
  props: SelectorProps
): boolean => {
  const device = deviceSelector(state, props)
  const schedules = schedulesSelector(state, props)

  if (!device || !device.META.scheduleIds || !schedules) return false
  return schedules.length === device.META.scheduleIds.length
}
